namespace distill.dashboards {
    class ColorPaletteEditor extends EditorBase {
        protected $presetSelect!: JQuery;
        protected $customContainer!: JQuery;
        protected $customGrid!: JQuery;
        protected parentPath!: string;

        init() {
            this.$presetSelect = this.$editor.find('.palette-preset-select');
            this.$customContainer = this.$editor.find('.custom-colors-container');
            this.$customGrid = this.$editor.find('.custom-colors-grid');

            if (this.propDef.path && this.propDef.path.includes('.'))
                this.parentPath = this.propDef.path.substring(0, this.propDef.path.lastIndexOf('.'));
            else
                this.parentPath = 'styling';

            Object.keys(DashColorPalettes).forEach(key => {
                this.$presetSelect.append($('<option>').val(key).text(key));
            });
            this.$presetSelect.append($('<option>').val('Custom').text('Custom'));
        }

        render() {
            super.render();
            appn.select.initForDesign({ elements: this.$presetSelect });
        }

        update(): void {
            const preset = this.getValue() as string;
            this.$presetSelect.val(preset).trigger('change.select2');

            if (preset === 'Custom') {
                this.$customContainer.showElement();
                this.renderCustomPickers();
            } else {
                this.$customContainer.hideElement();
            }
        }

        private getCustomColors(): string[] {
            const parentObj = appn.designerv2.getPropertyByPath(this.component, this.parentPath) || {};
            return parentObj['customColorPalette'] || [];
        }

        private saveCustomColors(newColors: string[]): void {
            const parentObj = appn.designerv2.getPropertyByPath(this.component, this.parentPath) || {};

            const updatedParent = { ...parentObj };
            updatedParent['customColorPalette'] = newColors;

            designer.updateComponentProperty(
                this.component.id,
                this.parentPath,
                updatedParent
            );
        }

        private renderCustomPickers(): void {
            this.$customGrid.empty();

            let customColors = this.getCustomColors();
            customColors = [...customColors];

            // Ensure 12 slots
            while (customColors.length < 12)
                customColors.push('#ffffff');

            customColors = customColors.slice(0, 12);

            customColors.forEach((color: string) => {
                const $picker = $('<input type="text" class="custom-color-picker form-control form-control-sm"/>');
                this.$customGrid.append($picker);

                ($picker as any).minicolors(new appn.minicolors.Options());
                ($picker as any).minicolors('value', color);

                $picker.on('change', () => {
                    if (this.$presetSelect.val() !== 'Custom') 
                        return;

                    const newColors: string[] = [];

                    this.$customGrid.find('.custom-color-picker').each(function() {
                        let val = $(this).val() as string;
                        if (!val || val.trim() === '' || val.trim() === '#')
                            val = '#ffffff';

                        newColors.push(val);
                    });

                    this.saveCustomColors(newColors);
                });
            });
        }

        bindEvents(): void {
            this.$presetSelect.on('change', (e) => {
                const selectedPreset = $(e.target).val() as string;
                if (selectedPreset === 'Custom') {
                    const currentColors = this.getCustomColors();
                    if (!currentColors || currentColors.length === 0) {
                        const defaultColors = DashColorPalettes['Vibrant'] || [];
                        this.saveCustomColors([...defaultColors]);
                    }
                }

                this.setValue(selectedPreset);
            });
        }
    }

    export class LegendStyleEditor extends EditorBase {
        protected $vPos!: JQuery;
        protected $hPos!: JQuery;

        init() {
            this.$vPos = this.$editor.find('.legend-vpos');
            this.$hPos = this.$editor.find('.legend-hpos');
        }

        render() {
            super.render();
            appn.select.initForDesign({ elements: this.$editor.find('select') });
        }

        update(): void {
            const style = this.getValue() as ILegendStyle || {};
            this.$vPos.val(style.verticalPosition || 'bottom').trigger('change.select2');
            this.$hPos.val(style.horizontalPosition || 'center').trigger('change.select2');
        }

        bindEvents(): void {
            this.$editor.on('change', 'select', () => {
                const vPos = this.$vPos.val() as 'top' | 'middle' | 'bottom';
                const hPos = this.$hPos.val() as 'left' | 'center' | 'right';
                const newStyle: ILegendStyle = {
                    verticalPosition: vPos,
                    horizontalPosition: hPos
                };
                this.setValue(newStyle);
            });
        }
    }

    export class ItemSelectorEditor extends EditorBase {
        protected $select!: JQuery;

        init() {
            this.$select = this.$editor.find('.item-selector');

            const itemList = designer.getItemList();
            if (itemList && itemList.length > 0) {
                itemList.forEach((folder: any) => {
                    const $option = $('<option>').val(folder.value).text(folder.text);
                    if (!folder.isArtifact)
                        $option.attr('data-is-doc', 'false');
                    this.$select.append($option);
                });
            }
        }

        render() {
            super.render();
            appn.select.initForDesign({ elements: this.$select });
        }

        update(): void {
            if (this.$select.find('option').length === 0)
                return;

            let value = this.getValue() as string[];

            if (!value) value = [];
            else if (!Array.isArray(value)) value = [value];

            this.$select.val(value);
            this.$select.trigger('change.select2');
        }

        bindEvents(): void {
            this.$select.on('select2:select select2:unselect', (e) => {
                const val = this.$select.val();
                const valueToSave = val === null ? [] : val;
                this.setValue(valueToSave);
            });
        }
    }
    
    
    editors.register('colorPalette', ColorPaletteEditor);
    editors.register('legendStyle', LegendStyleEditor);
    editors.register('itemSelector', ItemSelectorEditor);
}
